import { useMutationState } from "@tanstack/react-query";

import numbers from "core/numbers";
import strings from "core/strings";

import { useSecondaryAccount } from "features/auth/fabric";
import { useStart } from "features/start/fabric";

import { useMutateUser, useQueryHistory, useQueryUser, useMutatePass, useQueryDeposits, useQueryAccount, useMutateReload } from "areas/account/data";


export const useUser = () => {
	const query = useQueryUser();
	const mutation = useMutateUser();
	const auth = useSecondaryAccount();
	const user = query.data;

	const description = {
		name: user?.name || "What is your name?",
		nickname: user?.nickname || "How your name appears on your profile",
		email: user?.email?.value || "What is your email address?",
		phone: numbers.toPhone(user?.phone?.value?.slice(2)) || "What is your mobile phone number?" // todo: separate country code from phone in db (?)
	};

	const verified = {
		email: user?.email?.verified,
		phone: user?.phone?.verified
	};


	const updatePhone = async (v) => auth.mutation.mutate({ phone: v });
	const updateEmail = async (v) => auth.mutation.mutate({ email: v });

	const phone = query.data?.phone?.value?.slice(2); // todo: separate country code from phone in db (?)

	return { ...query, authMutation: auth.mutation, mutation, description, phone, updateEmail, updatePhone, verified };
};

export const useAccount = () => {
	const query = useQueryAccount();
	const mutation = useMutateReload();
	const start = useStart();
	const token = start.settings.token;
	const profile = query.data;

	const options = {
		threshold: token.options.threshold.map(t => ({ value: t, label: `${t} Tokens` })),
		amount: token.options.amount.map(o => ({ value: o.tokens, label: `${strings.pluralize(o.tokens, "Token")} (${numbers.format(o.price, "currency")})` }))
	};
	const selected = {
		threshold: options.threshold.find(o => o.value === profile?.threshold),
		amount: options.amount.find(o => o.value === profile?.reload) || options.amount.find(o => o.value === token.default.amount)
	};

	const confirmation = {
		threshold: (v) => `Auto reload when your account balance is below ${v} tokens`,
		amount: (v) => `This will set your auto reload deposit amount to ${v} tokens.`,
		reload: (v) => `${v ? "Disable" : "Enable"} auto reload on your account?`
	};

	const method = {
		description: profile?.defaultCard ? `Card ending in ${profile?.defaultCard}` : "Add your first card"
	};

	const checked = Boolean(profile?.reload);

	return { ...query, mutation, confirmation, checked, menu: { options, selected }, method };
};

export const useHistory = () => {
	const query = useQueryHistory();
	const mutationError = useMutationState({
		filters: {
			status: "error",
			predicate: (mutation) => {
				const key = mutation.options.mutationKey?.[0];
				return key === "article-gift-refund" || key === "article-read";
			}
		},
		select: (mutation) => mutation.state.error
	})?.[0];

	const list = query.data?.values;
	const pagination = query.data?.pagination;

	return { ...query, mutationError, list, pagination };
};

export const usePassHistory = () => {
	const mutation = useMutatePass();
	return { mutation };
};

export const useProfileDeposits = () => {
	const query = useQueryDeposits();
	const list = query.data?.values;
	const pagination = query.data?.pagination;

	return { ...query, list, pagination };
};